
define('ldsh!modules/start/products/sms/status/template', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 product-status-line">\n    ';
 if (productDetails.isRequest) { ;
__p += '\n        <div class="spinner__container">\n            <i class="ri-loader-4-fill fa-spin product-spinner"></i>\n        </div>\n    ';
 } else { ;
__p += '\n        ';
 if (noRecharges) { ;
__p += '\n            <div class="row">\n                <div class="col-md-12 col-lg-12">\n                    <p class="i18n" data-i18n="PUBLIC.PRODUCTS.SMS.LBL_NO_RECHARGES_1"></p>\n                    <p class="i18n" data-i18n="PUBLIC.PRODUCTS.SMS.LBL_NO_RECHARGES_2"></p>\n                </div>\n            </div>\n        ';
 } else { ;
__p += '\n            <div class="row row-same-height">\n                <div class="col-md-12 col-lg-12">\n                    <p><b class="i18n" data-i18n="PUBLIC.PRODUCTS.PRODUCT_LEFT"></b> <span class="product-number">' +
__e(formatNumber(numSmsAvailable)) +
'</span> <span class="i18n" data-i18n="PUBLIC.PRODUCTS.LBL_SMS"></span></p>\n                </div>\n            </div>\n        ';
 } ;
__p += '\n    ';
 } ;
__p += '\n</div>\n';

}
return __p
};});

